import Advisory from '../components/Committee/Advisory'
export default function AdvisoryCommittee() {
    return(
        <main className='mt-28'>
        <Advisory />
        </main>
    )
}